module.exports = __webpack_public_path__ + "img/aletho-logo.f9c0aaa0.png";